import React, { useEffect, useState } from "react";
import HSN from "../assets/images/HSN.jpg";
import HTY from "../assets/images/HTY.jpg";
import HTL from "../assets/images/HTL.jpg";
import HKT from "../assets/images/HKT.jpg";
import LHD from "../assets/images/LHD.jpg";
import HCC from "../assets/images/HCC.jpg";
import { Link } from "react-router-dom";
import axios from "axios";

const data = [
  {
    image: HSN,
    title: "HOA SINH NHẬT",
    slug: `hoa-sinh-nhat`,
  },
  {
    image: HTY,
    title: "HOA TÌNH YÊU",
    slug: `hoa-tinh-yeu`,
  },
  {
    image: HTL,
    title: "HOA TANG LỄ",
    slug: `hoa-tang-le`,
  },
  {
    image: HKT,
    title: "HOA KHAI TRƯƠNG",
    slug: `hoa-khai-truong`,
  },
  {
    image: LHD,
    title: "LAN HỒ ĐIỆP",
    slug: `lan-ho-diep`,
  },
  {
    image: HCC,
    title: "HOA CAO CẤP",
    slug: `hoa-cao-cap`,
  },
];

const FlowerCatalog = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`/api/v1/categories/popular`)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="flower-catalog-container">
      <div className="flower-title">
        <div className="flower-title-text">
          <i className="bi bi-heart me-2"></i>Danh Mục Sản Phẩm Hoa
        </div>
      </div>
      <div className="flower-content">
        {data.map((item, idx) => (
          <Link to={item.slug} key={idx}>
            <div className="flower-content-item" key={idx}>
              <div className="flower-img-item">
                <img src={item.image} alt="" />
              </div>
              <p>{item.name}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FlowerCatalog;
